// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type MetamaskAccessCodeQueryVariables = Exact<{
  site: string;
  address: string;
}>;


export type MetamaskAccessCodeQuery = { userManagement: { metamaskAccessCode: { accessCode: string | undefined } | undefined } | undefined };


export const MetamaskAccessCodeQueryDocument = gql`
    query MetamaskAccessCodeQuery($site: String!, $address: String!) {
  userManagement {
    metamaskAccessCode(site: $site, address: $address) {
      accessCode
    }
  }
}
    `;